import { Quote } from 'lucide-react';
import { about, processSteps } from '../data/content';

function Pipeline() {
  return (
    <div className="relative mt-20">
      {/* the pipe */}
      <svg className="absolute left-0 top-7 hidden h-4 w-full md:block" preserveAspectRatio="none" viewBox="0 0 1000 16" aria-hidden="true">
        <line x1="0" y1="8" x2="1000" y2="8" stroke="#e5e7eb" strokeWidth="14" strokeLinecap="round" />
        <line
          x1="0"
          y1="8"
          x2="1000"
          y2="8"
          stroke="#d02129"
          strokeWidth="4"
          strokeDasharray="14 26"
          className="animate-flow"
        />
      </svg>
      <ol className="relative grid gap-8 md:grid-cols-5 md:gap-4">
        {processSteps.map((s, i) => (
          <li key={s.title} className="reveal flex gap-4 md:flex-col md:items-center md:text-center">
            <span className="relative flex h-[4.5rem] w-[4.5rem] flex-none items-center justify-center rounded-full bg-white shadow-card ring-1 ring-gray-200">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink font-display text-sm font-bold text-white">
                0{i + 1}
              </span>
              <span className="absolute -right-1 -top-1 h-4 w-4 rounded-full border-2 border-white bg-brand-600" />
            </span>
            <span>
              <span className="block font-display text-lg font-bold text-ink md:mt-4">{s.title}</span>
              <span className="mt-1 block text-sm text-gray-500">{s.text}</span>
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function About() {
  return (
    <section id="about" className="grid-lines-dark relative bg-gray-50 pb-24 pt-32 lg:pb-32 lg:pt-40">
      <div className="container-x">
        <span className="eyebrow reveal">About Us</span>
        <h2 className="reveal mt-6 max-w-5xl font-display text-3xl font-bold leading-[1.15] text-ink sm:text-5xl lg:text-6xl">
          We design, build &amp; operate plants that give{' '}
          <span className="inline-block h-[0.85em] w-[2.2em] -translate-y-[0.05em] overflow-hidden rounded-full align-middle ring-2 ring-brand-600">
            <img src={`${process.env.PUBLIC_URL}/images/wtp.jpg`} alt="" className="h-full w-full object-cover" />
          </span>{' '}
          water a <span className="text-brand-600">second life.</span>
        </h2>

        <div className="mt-16 grid gap-12 lg:grid-cols-12">
          <aside className="reveal lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <div className="rounded-3xl bg-ink p-7 text-white">
                <div className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-400">
                  Delivery models
                </div>
                <ul className="mt-5 flex flex-wrap gap-2">
                  {about.schemes.map((s) => (
                    <li key={s} className="rounded-full bg-white/10 px-3.5 py-2 text-xs font-medium text-gray-200 ring-1 ring-white/10">
                      {s}
                    </li>
                  ))}
                </ul>
                <div className="mt-8 flex items-end justify-between border-t border-white/10 pt-6">
                  <span className="font-display text-5xl font-bold text-white">
                    DBO<span className="text-brand-500">.</span>
                  </span>
                  <span className="text-right text-xs leading-relaxed text-gray-400">
                    Design · Build
                    <br />
                    Operate
                  </span>
                </div>
              </div>
            </div>
          </aside>

          <div className="reveal space-y-6 text-lg leading-relaxed text-gray-600 lg:col-span-8">
            {about.paragraphs.map((p, i) => (
              <p key={i} className={i === 0 ? 'text-xl font-medium text-ink sm:text-2xl' : ''}>
                {p}
              </p>
            ))}
          </div>
        </div>

        <Pipeline />

        {/* Vision & Mission */}
        <div className="mt-28 grid gap-6 lg:grid-cols-5">
          <article className="reveal relative overflow-hidden rounded-[2rem] bg-white p-8 ring-1 ring-gray-200 sm:p-12 lg:col-span-2">
            <span className="pointer-events-none absolute -bottom-14 -right-2 select-none font-display text-[12rem] font-bold leading-none text-gray-900/[0.06] text-outline">
              V
            </span>
            <span className="eyebrow">Our Vision</span>
            <p className="relative mt-6 leading-relaxed text-gray-600">{about.vision}</p>
          </article>

          <article className="reveal relative overflow-hidden rounded-[2rem] bg-brand-600 p-8 text-white sm:p-12 lg:col-span-3">
            <span className="pointer-events-none absolute -bottom-14 -right-2 select-none font-display text-[12rem] font-bold leading-none text-white/20 text-outline">
              M
            </span>
            <span className="eyebrow !text-white before:!bg-white">Our Mission</span>
            <div className="relative mt-6 space-y-4 leading-relaxed text-white/90">
              {about.mission.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </article>
        </div>

        <figure className="reveal relative mt-6 overflow-hidden rounded-[2rem] bg-ink px-8 py-12 text-center sm:px-16">
          <Quote className="mx-auto h-10 w-10 text-brand-500" />
          <blockquote className="mx-auto mt-6 max-w-3xl font-display text-2xl font-semibold leading-snug text-white sm:text-4xl">
            {about.missionQuote}
          </blockquote>
        </figure>
      </div>
    </section>
  );
}
